/**
 * 平台工作区「全部店铺」范围：sentinel + 查询参数解析。
 * SHEIN / TEMU 共用。
 */

export const PLATFORM_ALL_SHOPS_ID = '__ALL__';

export function isAllShopsScope(shopId) {
  const id = String(shopId || '').trim();
  return id === PLATFORM_ALL_SHOPS_ID || id.toLowerCase() === 'all';
}

export function isConcreteShopId(shopId) {
  if (shopId == null || shopId === '') return false;
  if (isAllShopsScope(shopId)) return false;
  const n = Number(shopId);
  return Number.isFinite(n) && n > 0;
}

/**
 * 列表查询用：全部 → { allOfType: true }；具体店 → { shopId }
 * @param {string|number|null|undefined} scopeId
 * @returns {{ allOfType: true } | { shopId: string }}
 */
export function resolveShopQuery(scopeId) {
  if (isAllShopsScope(scopeId) || scopeId == null || scopeId === '') {
    return { allOfType: true };
  }
  return { shopId: String(scopeId) };
}

/**
 * 写/同步前解析具体店：无具体店返回 null（调用方弹窗选店）
 */
export function resolveConcreteShopId(scopeId) {
  return isConcreteShopId(scopeId) ? String(scopeId) : null;
}
